'use client';
import { useEffect, useState } from 'react';

/**
 * Where the calculator's app frame (#roi-app) sits relative to the screen. One measurement drives both floating controls, so they
 * can never show together (owner 2026-10-15):
 *   inView: enough of the calculator is on screen to work with  -> the phone bar (Adjust numbers + Build My System) shows
 *   past:   the calculator has scrolled out above the screen     -> the round Back to Calculator button shows
 * Between the two (the frame's last ~240px leaving the top of the screen) neither shows.
 */
export function useRoiFrame() {
  const [state, setState] = useState({ inView: false, past: false });
  useEffect(() => {
    const on = () => {
      const el = document.getElementById('roi-app');
      if (!el) return;
      const r = el.getBoundingClientRect();
      const inView = r.bottom > 140 && r.top < window.innerHeight - 80;
      const past = r.bottom < -100;
      setState((s) => (s.inView === inView && s.past === past ? s : { inView, past }));
    };
    on();
    window.addEventListener('scroll', on, { passive: true });
    window.addEventListener('resize', on);
    return () => { window.removeEventListener('scroll', on); window.removeEventListener('resize', on); };
  }, []);
  return state;
}
